import React, { Component } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { MsgBoxContainer, MsgBoxSaveContainer, MsgBoxConfirmContainer } from '../../components/Notifications/MsgBox'
import { logoutAction } from '../../redux/actions/UserAction'
import { ClearMasterAction } from '../../redux/actions/MasterAction'
import { AppSettings, Storage } from '../../configs'
import {
    MyTaskScreen,
    MainScreen,
    MainNotBotScreen,
    UploadFileScreen,
    SearchScreen,
    UserScreen,
    DepartmentScreen,
    DepartmentManageScreen,
    DocControlScreen,
    ManualScreen,
    ReportScreen,
    ReportPDFScreen,
    ReportReceiptScreen,
    AdjustmentScreen,
    AdjustmentDetailScreen,
    NotiAdjustmentScreen,
    NotiAdjustmentDetailScreen,
    ChangeCommitteeScreen,
    ChangeCommitteeTaskScreen,
    ReportOutstandingScreen,
    ExtendConsiderationPeriod,
    ExtendConsiderationPeriodAddScreen,
    SettingSessionTimeoutScreen,
    LoginScreen,
    HomeScreen
} from '../../screens';

import {
    Header,
    Footer,
    Loading
} from '../../components';

import {
    setActivePOAction,
    setNotActivePOAction,
}
    from '../../redux/actions/DocControlAction'

import '../../assets/css/custom.css'
import ContractPOManageScreen from '../../screens/ContractPOManage/ContractPOManageScreen';
//import AuditCommitteeScreen from '../../screens/AuditCommittee/AuditCommitteeScreen';
import Timeout from './Timeout'



class Full extends Component {

    constructor(props) {
        super(props)

        this.state = {
            user: Storage.getUser()
        }
        this.handleLogout = this.handleLogout.bind(this)
        this.beforeunload = this.beforeunload.bind(this)
        window.addEventListener('beforeunload', this.beforeunload);
    }


    componentDidUpdate(prevProps) {

        if (this.props.location !== prevProps.location && prevProps.location.pathname === "/main") {
            this.props.setNotActivePO(this.state.user.userName, null, this.props.sessionNo, false)
        }
    }

    componentDidMount() {
        window.addEventListener('beforeunload', this.beforeunload);
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.beforeunload);
    }

    handleLogout(event) {
        event.preventDefault()
        const employeePIS = Storage.getEmployeePIS()
        let userName = employeePIS.employeeId;
        this.props.setNotActivePO(userName, null, this.props.sessionNo, false)
        this.props.logout()
        this.props.ClearMaster()

        this.props.history.push({
            pathname: AppSettings.loginUrl,
            params: `?mode=logout`,
        })
    }

    handleLogoutTimeout() {
        const employeePIS = Storage.getEmployeePIS()
        let userName = employeePIS.employeeId;
        this.props.setNotActivePO(userName, null, this.props.sessionNo, false)
        this.props.logout()
        this.props.ClearMaster()

        this.props.history.push({
            pathname: AppSettings.loginUrl,
            params: `?mode=logout`,
        })
    }


    async beforeunload(e) {
        //e.preventDefault();
        //e.returnValue = '';
        await this.props.setNotActivePO(this.state.user.userName, null, this.props.sessionNo, true)
        //     var delay=1000*3;
        //     var start = new Date().getTime();
        //     while (new Date().getTime() < start + delay){
        //         //wiat
        //     };
    }

    render() {
        const { isLoading } = this.props

        const user = Storage.getUser()

        console.log('Storage.getUser()', user)

        return (
            <div className="app">
                <Timeout onLogout={()=>{ this.handleLogoutTimeout() }}></Timeout>
                {/* <Beforeunload onBeforeunload={() => {}} />             */}
                <div>
                    <div className="sp-body">
                        { user && user.token && <Header {...this.props} />}
                        <main className="main">

                            <Switch>
                            
                                <Route path="/mytask" name="MyTask" component={MyTaskScreen} />
                                <Route path="/main" name="Main" component={MainScreen} />
                                <Route path="/mainnotbot" name="MainNotBot" component={MainNotBotScreen} />
                                <Route path="/uploadfile" name="UploadFile" component={UploadFileScreen} />
                                <Route path="/Search" name="Search" component={SearchScreen} />
                                <Route path="/user" name="USer" component={UserScreen} />
                                <Route path="/departmentmap" name="DepartmentMap" component={DepartmentScreen} />
                                <Route path="/departmentmanage" name="DepartmentManage" component={DepartmentManageScreen} />
                                <Route path="/docControl" name="DocControl" component={DocControlScreen} />
                                <Route path="/manual" name="UserManual" component={ManualScreen} />
                                <Route path="/contractpomanage" name="ContractPOManage" component={ContractPOManageScreen} />
                                <Route path="/Report" name="Report" component={ReportScreen} />
                                <Route path="/ReportPDF" name="ReportPDF" component={ReportPDFScreen} />
                                <Route path="/ReportReceipt" name="ReportReceipt" component={ReportReceiptScreen} />
                                <Route path="/Adjustment" name="Adjustment" component={AdjustmentScreen} />
                                <Route path="/AdjustmentDetail/:adjustId" name="AdjustmentDetail" component={AdjustmentDetailScreen} />
                                <Route path="/NotiAdjustment" name="NotiAdjustment" component={NotiAdjustmentScreen} />
                                <Route path="/NotiAdjustmentDetail/:adjustId" name="NotiAdjustmentDetail" component={NotiAdjustmentDetailScreen} />
                                <Route path="/ChangeCommitteeTask" name="ChangeCommitteeTask" component={ChangeCommitteeTaskScreen} />
                                <Route path="/ChangeCommittee/:runningId" name="ChangeCommittee" component={ChangeCommitteeScreen} />
                                <Route path="/ReportOutstanding" name="Search" component={ReportOutstandingScreen} />
                                <Route path="/ExtendConsiderationPeriod" name="ExtendConsiderationPeriod" component={ExtendConsiderationPeriod} />
                                <Route path="/ExtendConsiderationPeriodItem/:extendId/:po_contract_no" name="ExtendConsiderationPeriodItemPO" component={ExtendConsiderationPeriodAddScreen} />
                                <Route path="/ExtendConsiderationPeriodItem/:extendId" name="ExtendConsiderationPeriodItem" component={ExtendConsiderationPeriodAddScreen} />
                                <Route path="/Configsessiontimeout" name="Configsessiontimeout" component={SettingSessionTimeoutScreen} />
                                <Route exact path="/home"  component={LoginScreen}  /> 
                                <Route exact path="/"  component={LoginScreen}  /> 
                                {/* <Redirect from="/" to="/login" />  */}

                            </Switch>
                        </main>
                    </div>
                    <Footer />
                </div>

                <MsgBoxContainer />
                <MsgBoxConfirmContainer />
                <MsgBoxSaveContainer />
                <Loading isLoading={isLoading} />
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { AppRedux, DocControlRedux } = state
    return {
        isLoading: AppRedux.isLoading,
        sessionNo: DocControlRedux.sessionNo,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        logout: () => dispatch(logoutAction()),
        ClearMaster: () => dispatch(ClearMasterAction()),
        setActivePO: (userId, poNo, sessionNo) => dispatch(setActivePOAction(userId, poNo, sessionNo)),
        setNotActivePO: (userId, poNo, sessionNo, isDelete) => dispatch(setNotActivePOAction(userId, poNo, sessionNo, isDelete)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Full);

